export type PeptideImageExt = "png" | "webp" | "jpg" | "jpeg" | "avif";

const AVAILABLE: Record<string, string> = {
	"5-amino-1mq": "/peptides/5-amino-1mq-10mg.png",
	"bac-water-10ml": "/peptides/bac-water-10ml.png",
	"bpc-157": "/peptides/bpc-157.png",
	"cjc-1295": "/peptides/cjc-1295.png",
	dsip: "/peptides/dsip-10mg.png",
	epithalon: "/peptides/epithalon.png",
	"ghk-cu": "/peptides/ghk-cu.png",
	"glow-stack": "/peptides/glow-stack.png",
	ipamorelin: "/peptides/ipamorelin.png",
	"mots-c": "/peptides/mots-c.png",
	"mt-2": "/peptides/mt-2.png",
	"nad-plus": "/peptides/nad-plus.png",
	pinealon: "/peptides/pinealon-10mg.png",
	retatrutide: "/peptides/retatrutide.png",
	selank: "/peptides/selank.png",
	semaglutide: "/peptides/semaglutide.png",
	semax: "/peptides/semax.png",
	sermorelin: "/peptides/sermorelin-5mg.png",
	"sermorelin-acetate": "/peptides/sermorelin-5mg.png",
	survodutide: "/peptides/survodutide-10mg.png",
	"tb-500": "/peptides/tb-500.png",
	"tb500-bpc157-blend": "/peptides/tb500-bpc157-blend.png",
	tesamorelin: "/peptides/tesamorelin.png",
	tirzepatid: "/peptides/tirzepatid.png",
};

/**
 * Variant-spezifische Bilder pro Produkt-Slug + Dosis.
 * Naming-Konvention: <slug>-<dose>.png (z.B. "retatrutide-10mg")
 * Wird als Fallback genutzt wenn Saleor keine variant.media hat.
 */
const VARIANT_AVAILABLE: Record<string, Record<string, string>> = {
	retatrutide: {
		"10mg": "/peptides/retatrutide-10mg.png",
		"15mg": "/peptides/retatrutide-15mg.png",
		"20mg": "/peptides/retatrutide-20mg.png",
		"30mg": "/peptides/retatrutide-30mg.png",
		"50mg": "/peptides/retatrutide-50mg.png",
	},
	tesamorelin: {
		"10mg": "/peptides/tesamorelin-10mg.png",
		"20mg": "/peptides/tesamorelin-20mg.png",
	},
	"ghk-cu": {
		"50mg": "/peptides/ghk-cu-50mg.png",
		"100mg": "/peptides/ghk-cu-100mg.png",
	},
	tirzepatid: {
		"10mg": "/peptides/tirzepatid-10mg.png",
		"60mg": "/peptides/tirzepatid-60mg.png",
	},
};

export function resolvePeptideImagePath(slug: string): string | null {
	return AVAILABLE[slug] ?? null;
}

/**
 * Resolve variant-specific image. Returns null if no local file maps for this product+dose.
 * Dose-extraction is tolerant: matches "10mg", "10 mg", "RETA-10MG-1VIAL" etc.
 */
export function resolveVariantImagePath(
	productSlug: string,
	variantName: string | null | undefined,
): string | null {
	const variants = VARIANT_AVAILABLE[productSlug];
	if (!variants || !variantName) return null;
	const m = variantName.match(/(\d+)\s*mg/i);
	if (!m) return null;
	const doseKey = `${m[1]}mg`;
	return variants[doseKey] ?? null;
}

export function hasPeptideImage(slug: string): boolean {
	return slug in AVAILABLE;
}
